import React, { useState, useEffect } from "react";
import {
  IonContent,
  IonRow,
  IonCard,
  IonCardHeader,
  IonCardTitle,
} from "@ionic/react";
import UserMobileOrEmailInput from "./components/userMobileOrEmailInput";
import OtpVerification from "./components/otpVerification";

import "../../styles/UserSignInComponent.css";
import "../../styles/style.css";

const Login = () => {
  const [displayOtpVerification, setDisplayOtpVerification] = useState(false);
  return (
    <>
      <IonContent className="Loginpage">
        <IonRow className="image-bg">
          <IonCard>
            {!displayOtpVerification && (
              <>
                <IonCardHeader>
                  <img alt="logo" src="img/logo.png" className="logo-img"></img>
                  <IonCardTitle>
                    <h1>Welcome Back!</h1>
                  </IonCardTitle>
                  <p>Login to your account using mobile number/email:</p>
                </IonCardHeader>

                <UserMobileOrEmailInput
                  setDisplayOtpVerification={setDisplayOtpVerification}
                />
              </>
            )}
            {displayOtpVerification && (
              <OtpVerification
                setDisplayOtpVerification={setDisplayOtpVerification}
              />
            )}
          </IonCard>
        </IonRow>
      </IonContent>
    </>
  );
};

export default Login;
